import { createFileRoute } from '@tanstack/react-router'
import { PermissionRouteGuard } from '@/hooks/usePermissions'
import { OrdersPage } from '@/pages/Orders'

export const Route = createFileRoute('/_authenticated/orders')({
  component: OrdersGuard,
})

function OrdersGuard() {
  return (
    <PermissionRouteGuard resource="orders" action="read">
      <OrdersPage />
    </PermissionRouteGuard>
  )
}
